import { render, staticRenderFns } from "./MyPageEdit.vue?vue&type=template&id=5addcf9c&scoped=true&"
import script from "./MyPageEdit.vue?vue&type=script&lang=js&"
export * from "./MyPageEdit.vue?vue&type=script&lang=js&"
import style0 from "./MyPageEdit.vue?vue&type=style&index=0&id=5addcf9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5addcf9c",
  null
  
)

export default component.exports